/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BookingKeyCreateDTO } from '../models';
// @ts-ignore
import type { BookingKeyResponseDTO } from '../models';
// @ts-ignore
import type { BookingKeyUpdateDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * BookingKeysApi - axios parameter creator
 * @export
 */
export const BookingKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
         * @summary Create Booking Key
         * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingKeyApiV1BookingKeysPost: async (bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyCreateDTO' is not null or undefined
            assertParamExists('createBookingKeyApiV1BookingKeysPost', 'bookingKeyCreateDTO', bookingKeyCreateDTO)
            const localVarPath = `/api/v1/booking-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingKeyCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
         * @summary Create Booking Key
         * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingKeyApiV1BookingKeysPost_1: async (bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyCreateDTO' is not null or undefined
            assertParamExists('createBookingKeyApiV1BookingKeysPost_1', 'bookingKeyCreateDTO', bookingKeyCreateDTO)
            const localVarPath = `/api/v1/booking-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingKeyCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete: async (bookingKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete', 'bookingKeyId', bookingKeyId)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2: async (bookingKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2', 'bookingKeyId', bookingKeyId)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete: async (bookingKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete', 'bookingKeyId', bookingKeyId)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}/logo`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3: async (bookingKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3', 'bookingKeyId', bookingKeyId)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}/logo`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
         * @summary Get Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingKeyApiV1BookingKeysBookingKeyIdGet: async (bookingKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('getBookingKeyApiV1BookingKeysBookingKeyIdGet', 'bookingKeyId', bookingKeyId)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
         * @summary Get Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingKeyApiV1BookingKeysBookingKeyIdGet_4: async (bookingKeyId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('getBookingKeyApiV1BookingKeysBookingKeyIdGet_4', 'bookingKeyId', bookingKeyId)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
         * @summary List Booking Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookingKeysApiV1BookingKeysGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/booking-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
         * @summary List Booking Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookingKeysApiV1BookingKeysGet_5: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/booking-keys/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
         * @summary Set Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut: async (bookingKeyId: string, file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut', 'bookingKeyId', bookingKeyId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut', 'file', file)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}/logo`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
         * @summary Set Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6: async (bookingKeyId: string, file: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6', 'bookingKeyId', bookingKeyId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6', 'file', file)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}/logo`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
         * @summary Update Booking Key
         * @param {string} bookingKeyId 
         * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingKeyApiV1BookingKeysBookingKeyIdPatch: async (bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('updateBookingKeyApiV1BookingKeysBookingKeyIdPatch', 'bookingKeyId', bookingKeyId)
            // verify required parameter 'bookingKeyUpdateDTO' is not null or undefined
            assertParamExists('updateBookingKeyApiV1BookingKeysBookingKeyIdPatch', 'bookingKeyUpdateDTO', bookingKeyUpdateDTO)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingKeyUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
         * @summary Update Booking Key
         * @param {string} bookingKeyId 
         * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7: async (bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingKeyId' is not null or undefined
            assertParamExists('updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7', 'bookingKeyId', bookingKeyId)
            // verify required parameter 'bookingKeyUpdateDTO' is not null or undefined
            assertParamExists('updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7', 'bookingKeyUpdateDTO', bookingKeyUpdateDTO)
            const localVarPath = `/api/v1/booking-keys/{booking_key_id}`
                .replace(`{${"booking_key_id"}}`, encodeURIComponent(String(bookingKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingKeyUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingKeysApi - functional programming interface
 * @export
 */
export const BookingKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
         * @summary Create Booking Key
         * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingKeyApiV1BookingKeysPost(bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingKeyApiV1BookingKeysPost(bookingKeyCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.createBookingKeyApiV1BookingKeysPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
         * @summary Create Booking Key
         * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBookingKeyApiV1BookingKeysPost_1(bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBookingKeyApiV1BookingKeysPost_1(bookingKeyCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.createBookingKeyApiV1BookingKeysPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete(bookingKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2(bookingKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete(bookingKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3(bookingKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
         * @summary Get Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingKeyApiV1BookingKeysBookingKeyIdGet(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingKeyApiV1BookingKeysBookingKeyIdGet(bookingKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.getBookingKeyApiV1BookingKeysBookingKeyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
         * @summary Get Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBookingKeyApiV1BookingKeysBookingKeyIdGet_4(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBookingKeyApiV1BookingKeysBookingKeyIdGet_4(bookingKeyId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.getBookingKeyApiV1BookingKeysBookingKeyIdGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
         * @summary List Booking Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBookingKeysApiV1BookingKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingKeyResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBookingKeysApiV1BookingKeysGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.listBookingKeysApiV1BookingKeysGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
         * @summary List Booking Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBookingKeysApiV1BookingKeysGet_5(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingKeyResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBookingKeysApiV1BookingKeysGet_5(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.listBookingKeysApiV1BookingKeysGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
         * @summary Set Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut(bookingKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut(bookingKeyId, file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
         * @summary Set Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6(bookingKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6(bookingKeyId, file, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
         * @summary Update Booking Key
         * @param {string} bookingKeyId 
         * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBookingKeyApiV1BookingKeysBookingKeyIdPatch(bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBookingKeyApiV1BookingKeysBookingKeyIdPatch(bookingKeyId, bookingKeyUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.updateBookingKeyApiV1BookingKeysBookingKeyIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
         * @summary Update Booking Key
         * @param {string} bookingKeyId 
         * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7(bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingKeyResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7(bookingKeyId, bookingKeyUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingKeysApi.updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BookingKeysApi - factory interface
 * @export
 */
export const BookingKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingKeysApiFp(configuration)
    return {
        /**
         * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
         * @summary Create Booking Key
         * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingKeyApiV1BookingKeysPost(bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.createBookingKeyApiV1BookingKeysPost(bookingKeyCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
         * @summary Create Booking Key
         * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBookingKeyApiV1BookingKeysPost_1(bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.createBookingKeyApiV1BookingKeysPost_1(bookingKeyCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete(bookingKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2(bookingKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete(bookingKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
         * @summary Delete Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3(bookingKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
         * @summary Get Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingKeyApiV1BookingKeysBookingKeyIdGet(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.getBookingKeyApiV1BookingKeysBookingKeyIdGet(bookingKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
         * @summary Get Booking Key
         * @param {string} bookingKeyId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBookingKeyApiV1BookingKeysBookingKeyIdGet_4(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.getBookingKeyApiV1BookingKeysBookingKeyIdGet_4(bookingKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
         * @summary List Booking Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookingKeysApiV1BookingKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingKeyResponseDTO>> {
            return localVarFp.listBookingKeysApiV1BookingKeysGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
         * @summary List Booking Keys
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBookingKeysApiV1BookingKeysGet_5(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BookingKeyResponseDTO>> {
            return localVarFp.listBookingKeysApiV1BookingKeysGet_5(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
         * @summary Set Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut(bookingKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut(bookingKeyId, file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
         * @summary Set Booking Key Logo
         * @param {string} bookingKeyId 
         * @param {string} file 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6(bookingKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6(bookingKeyId, file, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
         * @summary Update Booking Key
         * @param {string} bookingKeyId 
         * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingKeyApiV1BookingKeysBookingKeyIdPatch(bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.updateBookingKeyApiV1BookingKeysBookingKeyIdPatch(bookingKeyId, bookingKeyUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
         * @summary Update Booking Key
         * @param {string} bookingKeyId 
         * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7(bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BookingKeyResponseDTO> {
            return localVarFp.updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7(bookingKeyId, bookingKeyUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingKeysApi - object-oriented interface
 * @export
 * @class BookingKeysApi
 * @extends {BaseAPI}
 */
export class BookingKeysApi extends BaseAPI {
    /**
     * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
     * @summary Create Booking Key
     * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public createBookingKeyApiV1BookingKeysPost(bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).createBookingKeyApiV1BookingKeysPost(bookingKeyCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a booking key for the current organization.  The returned ``key`` is a PUBLIC identifier shipped in the booking-page URL; it can be re-read at any time. ``calendar_ids`` and ``event_type_ids`` are the key\'s authorization scope; an empty scope is accepted but leaves the key inert (nothing bookable) until links are configured.  Requires \'booking_key:write\' permission.
     * @summary Create Booking Key
     * @param {BookingKeyCreateDTO} bookingKeyCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public createBookingKeyApiV1BookingKeysPost_1(bookingKeyCreateDTO: BookingKeyCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).createBookingKeyApiV1BookingKeysPost_1(bookingKeyCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
     * @summary Delete Booking Key
     * @param {string} bookingKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete(bookingKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a booking key (soft delete — sets ``is_active=False``).  The row is kept and still listed so it can be reactivated via PATCH. Requires \'booking_key:write\' permission.
     * @summary Delete Booking Key
     * @param {string} bookingKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).deleteBookingKeyApiV1BookingKeysBookingKeyIdDelete_2(bookingKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
     * @summary Delete Booking Key Logo
     * @param {string} bookingKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete(bookingKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the booking page\'s logo image.  Requires \'booking_key:write\' permission.
     * @summary Delete Booking Key Logo
     * @param {string} bookingKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).deleteBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoDelete_3(bookingKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
     * @summary Get Booking Key
     * @param {string} bookingKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public getBookingKeyApiV1BookingKeysBookingKeyIdGet(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).getBookingKeyApiV1BookingKeysBookingKeyIdGet(bookingKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific booking key by ID (full key value included).  Requires \'booking_key:view\' permission.
     * @summary Get Booking Key
     * @param {string} bookingKeyId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public getBookingKeyApiV1BookingKeysBookingKeyIdGet_4(bookingKeyId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).getBookingKeyApiV1BookingKeysBookingKeyIdGet_4(bookingKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
     * @summary List Booking Keys
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public listBookingKeysApiV1BookingKeysGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).listBookingKeysApiV1BookingKeysGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all booking keys for the organization, including revoked (inactive) ones.  Requires \'booking_key:view\' permission.
     * @summary List Booking Keys
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public listBookingKeysApiV1BookingKeysGet_5(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).listBookingKeysApiV1BookingKeysGet_5(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
     * @summary Set Booking Key Logo
     * @param {string} bookingKeyId 
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut(bookingKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut(bookingKeyId, file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload (or replace) the booking page\'s logo image.  PNG format and size limits are enforced by the service. The returned DTO includes the resulting ``logo_url``.  Requires \'booking_key:write\' permission.
     * @summary Set Booking Key Logo
     * @param {string} bookingKeyId 
     * @param {string} file 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6(bookingKeyId: string, file: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).setBookingKeyLogoApiV1BookingKeysBookingKeyIdLogoPut_6(bookingKeyId, file, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
     * @summary Update Booking Key
     * @param {string} bookingKeyId 
     * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public updateBookingKeyApiV1BookingKeysBookingKeyIdPatch(bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).updateBookingKeyApiV1BookingKeysBookingKeyIdPatch(bookingKeyId, bookingKeyUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a booking key\'s label, active status, styling, or scope links.  Providing ``calendar_ids`` / ``event_type_ids`` replaces that link set in full; omitting a list leaves it untouched. The key value itself is immutable — create a new key instead. A ``PATCH is_active=true`` reactivates a revoked key.  Requires \'booking_key:write\' permission.
     * @summary Update Booking Key
     * @param {string} bookingKeyId 
     * @param {BookingKeyUpdateDTO} bookingKeyUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingKeysApi
     */
    public updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7(bookingKeyId: string, bookingKeyUpdateDTO: BookingKeyUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return BookingKeysApiFp(this.configuration).updateBookingKeyApiV1BookingKeysBookingKeyIdPatch_7(bookingKeyId, bookingKeyUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

